import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.span`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Strike = styled.span`
    border: 1px solid ${({ theme }) => theme.text};
    transform: rotate(${({ state }) => state ? 90 : 450}deg);
    height: 0.5em;
    position: absolute;
    transition: all 0.35s ease-in-out;
`
const Strike2 = styled(Strike)`
    transform: rotate(${({ state }) => state ? 0 : 90}deg);
    height: ${({ state }) => state ? 0.5 : 0}em;
    border:  ${({ state }) => state ? 1 : 0}px solid ${({ theme }) => theme.text};
`

const Closable = ({ state, ...props}) => {
    return (
        <Wrapper {...props}>
            <Strike state={state ? 1 : 0} />
            <Strike2 state={state ? 1 : 0} />
        </Wrapper>
    )
}

export default Closable;